import React from "react";
import SectionContainer from "../../components/SectionContainer";
import SectionHead from "../../components/SectionHead";
import PricingBlock from "./PricingBlock";

const Pricing = () => {
  return (
    <SectionContainer id={"pricing"} secName={"pricing-sec"}>
      <SectionHead
        head={"pricing"}
        text={
          "The cost of software development services can vary widely depending on a number of factors, including the complexity of the project, the expertise and experience of the development team, the technologies and tools used, and the geographical location of the development team."
        }
      />
      <PricingBlock />
    </SectionContainer>
  );
};

export default Pricing;
